import './styles/serviceportal.scss';
import './polyfills';
import './linker';
import Vue from 'vue';
import './components';
import './riReplaceHyphen';
import { formatDate, formatDateTime, dayOfWeek } from './central/formatDate';
Vue.filter('hyphen', function (value) {
    return window.riReplaceWithHyphen(value);
});
Vue.filter('formatDate', function (value) {
    return formatDate(value);
});
Vue.filter('formatDateTime', function (value) {
    return formatDateTime(value);
});
Vue.filter('dayOfWeek', function (value) {
    return dayOfWeek(value);
});
Vue.filter('fullName', function (value) {
    if (value && value.split) {
        var parts = value.split(',');
        if (parts.length === 2) {
            return parts[1].trim() + ' ' + parts[0].trim();
        }
        return value;
    }
});
Vue.filter('prepend', function (value, prependage) {
    if (!value) {
        return '';
    }
    if (!prependage) {
        return value;
    }
    return prependage + " " + value;
});
